import mobileLogo from './../../icons/mobile-logo.svg';
import logo from './../../images/pragma-go-logo.png';
import { useMediaQuery } from 'react-responsive';
import { Link } from 'react-router-dom';

const Logo = ({ forceDesktop }) => {
  const isMobile = useMediaQuery({
    query: '(max-width: 767px)',
  });
  const isMiniLogo = !forceDesktop && isMobile;
  return (
    <div className='logo-box'>
      <Link to='/'>
        <img src={isMiniLogo ? mobileLogo : logo} alt='Logo' />
      </Link>
    </div>
  );
};

export default Logo;
